import { render, staticRenderFns } from "./NewDatabase.vue?vue&type=template&id=b79bc4b8&"
import script from "./NewDatabase.vue?vue&type=script&lang=js&"
export * from "./NewDatabase.vue?vue&type=script&lang=js&"
import style0 from "./NewDatabase.vue?vue&type=style&index=0&id=b79bc4b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports